import { styled } from "@bvhi/ui-base";
import { MaterialDesignContent } from "notistack";

export const NotistackAlert = styled(MaterialDesignContent)(() => ({
  "&.notistack-MuiContent": {
    whiteSpace: "pre-line",
  },
}));
